var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHappyFace = function SvgHappyFace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 2C7.149 2 2 7.149 2 13.5S7.149 25 13.5 25 25 19.851 25 13.5 19.851 2 13.5 2ZM0 13.5C0 6.044 6.044 0 13.5 0S27 6.044 27 13.5 20.956 27 13.5 27 0 20.956 0 13.5Z",
    fill: "#102B3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM17.5 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    fill: "#102B3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.188 19.802a5.472 5.472 0 0 0 4.502-2.212 1 1 0 1 1 1.606 1.192 7.473 7.473 0 0 1-6.129 3.02 7.175 7.175 0 0 1-3.878-1.079 8.747 8.747 0 0 1-2.077-1.92 1 1 0 1 1 1.576-1.23c.447.574.984 1.07 1.59 1.472a5.175 5.175 0 0 0 2.81.757Z",
    fill: "#102B3F"
  })));
};
export default SvgHappyFace;